import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    addRecord,
    addRecordSuccess,
    addRecordFailure,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    deleteRecord,
    deleteRecordSuccess,
    deleteRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    handleFlow,
    handleFlowSuccess,
    handleFlowFailure,
    resendWorkflowStepSuccess,
    resendWorkflowStepFailure,
    resendWorkflowStep,
    restartWorkflow,
    restartWorkflowSuccess,
    restartWorkflowFailure
} from './dossier-workflow.action';


import {
    fetchSingleRecord as WFetchSingleRecord,
    fetchSingleRecordSuccess as WFetchSingleRecordSuccess,
    fetchSingleRecordFail as WFetchSingleRecordFail,
} from '../Workflows/workflows.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { DossierWorkflowTableService } from './dossier-workflow-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { ResponseService } from '../response/response-service.model';


@Injectable()
export class DossierWorkflowRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data: any) => {
                const url = 'dossier/'+data.dossierId+'/dossier-workflow';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {
                        const data = response.data;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        this.moduleTableService.workflow = data.workflow;

                        this.store.dispatch(WFetchSingleRecordSuccess({singleData: data.workflow, steps: []}));

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    addData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addRecord),
            exhaustMap((data: any) => {
                const url = 'dossier/'+data.dossierId+'/dossier-workflow';
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords({dossierId: this.moduleTableService.dossierId}));
                        return addRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => addRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );
    
    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'dossier/'+data.dossierId+'/dossier-workflow/'+data.id+"/edit";
                return this.crudServerService.fetchData(url,).pipe(
                    map( (response: ResponseService) => {
                        const dossierWorkflow = response.data.record;
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchSingleRecordSuccess({singleData: dossierWorkflow});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = "dossier/"+data.dossierId+'/dossier-workflow-update/'+data.id;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords({dossierId: this.moduleTableService.dossierId}));
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    handleFlow$ = createEffect(() =>
        this.actions$.pipe(
            ofType(handleFlow),
            exhaustMap((data:any) => {
                const url = "dossier/"+data.dossierId+'/dossier-workflow-status/'+data.shouldPause;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords({dossierId: this.moduleTableService.dossierId}));
                        return handleFlowSuccess();
                    }),
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => handleFlowFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    restartWorkflow$ = createEffect(() =>
        this.actions$.pipe(
            ofType(restartWorkflow),
            exhaustMap((data:any) => {
                const url = "dossier/"+data.dossierId+'/restart-workflow';
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords({dossierId: this.moduleTableService.dossierId}));
                        return restartWorkflowSuccess();
                    }),
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => restartWorkflowFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                const url = "dossier/"+data.dossierId+'/dossier-workflow/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords({dossierId: this.moduleTableService.dossierId}));
                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    resendWorkflowStep$ = createEffect(() =>
        this.actions$.pipe(
            ofType(resendWorkflowStep),
            exhaustMap((data: any) => {
                const url = 'resend-dossier-step/'+data.stepId;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return resendWorkflowStepSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => resendWorkflowStepFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private moduleTableService: DossierWorkflowTableService,
        private tableService: DatatableService,
    ) { }

}